import PropTypes from 'prop-types' // eslint-disable-line no-unused-vars
import { Component } from 'react'
import gifProps from 'shared/prop-types/gif'
import css from './link-shortener.css'
import { gifShortener } from 'shared/api/index'

/**
 * GIF Detail - Link Shortener: returns a link
 * that previews on social platforms with the current page's gif
 * but links through to the given URL.
 *
 * @class LinkShortener
 */
export default class extends Component {
    static propTypes = {
        gif: gifProps.isRequired,
    }
    state = {
        inputValue: '',
        buttonText: 'Shorten',
        shortUrl: '',
        canEdit: true,
        progress: 'default',
    }
    editInput(e) {
        e.target.select()
        this.setState({
            inputValue: this.state.shortUrl,
            canEdit: true,
        })
    }
    async shortenUrl() {
        const { gif } = this.props
        let { inputValue } = this.state

        if (!inputValue.trim().length) {
            this.setState({
                buttonText: 'Need link',
                progress: 'error',
            })
            return
        }

        this.setState({
            buttonText: 'Shortening',
            progress: 'saving',
        })

        const formData = new FormData()
        formData.append('gif_id', gif.id)
        formData.append('redirect_to', inputValue)

        try {
            const { short_url } = await gifShortener(formData)
            this.setState({
                shortUrl: short_url,
                buttonText: 'Booyah!',
                canEdit: false,
                progress: 'success',
            })
        } catch (e) {
            this.setState({
                shortUrl: '',
                buttonText: 'Oops!',
                progress: 'error',
            })
        }
    }
    handleChange(e) {
        this.setState({
            inputValue: e.target.value,
            canEdit: true,
        })
    }
    render() {
        const { buttonText, shortUrl, canEdit, progress } = this.state

        return (
            <div className={css.container}>
                <input
                    className={css.input}
                    type="text"
                    placeholder={'Enter a URL to shorten'}
                    value={canEdit ? this.state.inputValue : shortUrl}
                    onChange={e => this.handleChange(e)}
                    onClick={e => this.editInput(e)}
                    onFocus={e => this.editInput(e)}
                    onCopy={() => global.showSuccess(`Gif Shortener URL copied to clipboard!`)}
                />
                <div className={css[progress]} onClick={() => this.shortenUrl()}>
                    {buttonText}
                </div>
            </div>
        )
    }
}
